import { FilterNameKey } from "@src/types/weddingHallFilter";

export const REGION_DATA = [
  {
    region: "서울",
    subRegions: [
      // "전체",
      "강남",
      "서초",
      "영등포/구로",
      "강서/양천/마포",
      "송파/강동",
      "용산/중구/종로",
      "광진/성동",
      "관악/동작/금천",
      "성북/강북",
      "동대문/중랑",
      "노원/도봉",
      "은평/서대문",
    ],
  },
  {
    region: "경기",
    subRegions: [
      // "전체",
      "수원",
      "용인",
      "안양/의왕/군포",
      "부천",
      "광명",
      "시흥/안산",
      "성남/광주/하남",
      "화성/평택/오산",
      "고양/김포/파주",
      "양주/의정부",
      "남양주/구리",
    ],
  },
  {
    region: "인천",
    subRegions: [],
  },
  {
    region: "부산",
    subRegions: [],
  },
  {
    region: "대구",
    subRegions: [],
  },
  {
    region: "광주",
    subRegions: [],
  },
  // {
  //   region: "부산",
  //   subRegions: [],
  // },
  {
    region: "대전",
    subRegions: [],
  },
  {
    region: "울산", //신규
    subRegions: [],
  },
  {
    region: "세종", //신규
    subRegions: [],
  },
  {
    region: "강원",
    subRegions: [],
  },
  {
    region: "충북",
    subRegions: [],
  },
  {
    region: "충남",
    subRegions: [],
  },
  {
    region: "전북",
    subRegions: [],
  },
  {
    region: "전남",
    subRegions: [],
  },
  // {
  //   region: "강원",
  //   subRegions:[],
  // },
  // {
  //   region: "충북",
  //   subRegions:[],
  // },
  // {
  //   region: "충남",
  //   subRegions: [],
  // },
  {
    region: "경북",
    subRegions: [],
  },
  {
    region: "경남",
    subRegions: [],
  },
  {
    region: "제주", //신규
    subRegions: [],
  },
];
export const findRegionBySubRegion = (subRegion: string) => {
  for (const region of REGION_DATA) {
    if (
      region.subRegions.some((sub) => sub.split("/").some((subPart) => subRegion.includes(subPart)))
    ) {
      return region.region;
    }
  }
  return "";
};
export const getRegionBySubRegion = (subRegion: string) => {
  for (const region of REGION_DATA) {
    if (region.subRegions.some((sub) => sub.includes(subRegion))) {
      return region.region;
    }
  }
  return "";
};
export const isAllSubRegionSelected = (region: string, subRegion: string[]) => {
  const regionData = REGION_DATA.find((r) => r.region === region);
  if (!regionData) return false;
  return subRegion.every((sr) => regionData.subRegions.includes(sr));
};
export const makeRegionsParam = (region: string, subRegion: string[]) => {
  const regionArr = [];
  region.split(", ").forEach((region) => {
    // region 지역 전체를 필터
    if (region) regionArr.push(region);
  });
  subRegion
    .join(",")
    .replaceAll("/", ",")
    .split(",")
    .forEach((subRegion) => {
      if (!subRegion) return;
      const mRegion = findRegionBySubRegion(subRegion);
      // subRegion 값이 있다면 전체 region은 지워준다.
      if (regionArr.includes(mRegion)) regionArr.splice(regionArr.indexOf(mRegion), 1);
      regionArr.push(`${mRegion}-${subRegion}`);
    });
  return regionArr;
};

// filter data
export const HALL_FILTER_DEFAULT_SORT_TYPE = "추천순";
export const HALL_FILTER_DEFAULT_MAX_GUARANTEE = 350;
export const HALL_FILTER_DEFAULT_MIN_GUARANTEE = 0;
export const HALL_FILTER_DETAULT_DATA: {
  [key in FilterNameKey]?: string | string[];
} = {
  HALL_LEVEL: "CONTRACT_AND_RESERVE",
  HALL_TYPE: [],
  MEAL_TYPE: [],
  ENTRANCE_METHOD: [],
  PARKING: [],
  TRAFFIC: [],
  VIRGIN_ROAD: [],
  ETC: [],
  WEDDING_DAY: [],
  WEDDING_TIME: [],
};
export const HALL_FILTER_DATA: {
  [key in FilterNameKey]?: {
    name: string;
    key: string | string[];
    value?: string | string[];
    typeName: FilterNameKey;
  }[];
} = {
  // value: 서버로 보낼 데이터가 고정된 경우. 만약 value가 없다면 고정 되지 않은 값이라 이 데이터를 가져가서 사용하는 곳 에서 직접 설정해줘야함.
  // key: 서버로 보낼 파라미터 이름
  HALL_LEVEL: [
    // { name: '전체', value: 'CONTRACT_AND_RESERVE', key: ['contract', 'reserve'], typeName: 'HALL_LEVEL' },
    { name: "즉시 방문 예약", value: "RESERVE", key: "reserve", typeName: "HALL_LEVEL" },
    { name: "즉시 잔여타임 선점", value: "CONTRACT", key: "contract", typeName: "HALL_LEVEL" },
  ],
  HALL_TYPE: [
    { name: "밝은", value: "BRIGHT", key: "styles", typeName: "HALL_TYPE" },
    { name: "어두운", value: "DARK", key: "styles", typeName: "HALL_TYPE" },
    { name: "채플", value: "CHAPEL", key: "styles", typeName: "HALL_TYPE" },
    { name: "컨벤션", value: "CONVENTION", key: "styles", typeName: "HALL_TYPE" },
    { name: "하우스", value: "HOUSE", key: "styles", typeName: "HALL_TYPE" },
    { name: "호텔", value: "HOTEL", key: "styles", typeName: "HALL_TYPE" },
    { name: "야외", value: "OUTDOOR", key: "styles", typeName: "HALL_TYPE" },
    { name: "한옥", value: "HANOK", key: "styles", typeName: "HALL_TYPE" },
    { name: "소규모", value: "SMALL_SCALE", key: "styles", typeName: "HALL_TYPE" },
  ],
  MEAL_TYPE: [
    { name: "뷔페", value: "BUFFET", key: "meals", typeName: "MEAL_TYPE" },
    { name: "한상차림", value: "ONE_TABLE", key: "meals", typeName: "MEAL_TYPE" },
    { name: "코스", value: "COURSE", key: "meals", typeName: "MEAL_TYPE" },
    {
      name: "한상차림 + 세미뷔페",
      value: "ONE_TABLE_WITH_SEMI_BUFFET",
      key: "meals",
      typeName: "MEAL_TYPE",
    },
    // { name: '분리예식', value: 'SEPERATION', key: 'meals', typeName: 'MEAL_TYPE' },
    // { name: '동시예식', value: 'SAME_TIME', key: 'meals', typeName: 'MEAL_TYPE' },
  ],
  WEDDING_METHOD: [
    { name: "분리예식", value: "SEPARATION", key: "meals", typeName: "WEDDING_METHOD" },
    { name: "동시예식", value: "SAME_TIME", key: "meals", typeName: "WEDDING_METHOD" },
  ],
  ENTRANCE_METHOD: [
    {
      name: "신부대기실에서 바로 입장",
      value: "DIRECT",
      key: "entrance",
      typeName: "ENTRANCE_METHOD",
    },
    { name: "계단을 통해 입장", value: "VIA_STAIRS", key: "entrance", typeName: "ENTRANCE_METHOD" },
    {
      name: "히든공간을 통해 입장",
      value: "VIA_HIDDEN_SPACE",
      key: "entrance",
      typeName: "ENTRANCE_METHOD",
    },
    { name: "리프트를 통해 입장", value: "VIA_LIFT", key: "entrance", typeName: "ENTRANCE_METHOD" },
    { name: "정면에서 입장", value: "FROM_FRONT", key: "entrance", typeName: "ENTRANCE_METHOD" },
    { name: "로비에서 입장", value: "FROM_LOBBY", key: "entrance", typeName: "ENTRANCE_METHOD" },
    { name: "ㄱ자 입장", value: "L_SHAPE", key: "entrance", typeName: "ENTRANCE_METHOD" },
    { name: "ㄴ자 입장", value: "U_SHAPE", key: "entrance", typeName: "ENTRANCE_METHOD" },
    { name: "ㄷ자 입장", value: "Z_SHAPE", key: "entrance", typeName: "ENTRANCE_METHOD" },
    { name: "기타", value: "ETC", key: "entrance", typeName: "ENTRANCE_METHOD" },
  ],
  PARKING: [
    { name: "대절버스", key: "busRent", value: "BUSRENT", typeName: "PARKING" },
    { name: "500대 이상", key: "parkingSpace", value: "PARKINGSPACE", typeName: "PARKING" },
  ],
  TRAFFIC: [
    { name: "역세권", key: "stationArea", value: "STATIONAREA", typeName: "TRAFFIC" },
    { name: "셔틀버스", key: "shuttle", value: "SHUTTLE", typeName: "TRAFFIC" },
  ],
  PARK_TRAFFIC: [
    {
      name: "지하철역에서 도보 15분 이내",
      key: "stationArea",
      value: "STATIONAREA",
      typeName: "PARK_TRAFFIC",
    },
    { name: "셔틀버스 운행", key: "shuttle", value: "SHUTTLE", typeName: "PARK_TRAFFIC" },
    { name: "대절버스 주차 가능", key: "busRent", value: "BUSRENT", typeName: "PARK_TRAFFIC" },
  ],
  VIRGIN_ROAD: [
    // { name: '곡선 버진로드', value: 'virginRoadType', key: 'virginRoadType', typeName: 'VIRGIN_ROAD' }, // value로 하드코딩 해야함.
    {
      name: "길이 10m 이상",
      value: "virginRoadLength",
      key: "virginRoadLength",
      typeName: "VIRGIN_ROAD",
    }, // value로 하드코딩 해야함.
    {
      name: "하객석과 단차 있음",
      value: "virginRoadStage",
      key: "virginRoadStage",
      typeName: "VIRGIN_ROAD",
    }, // value로 하드코딩 해야함.
  ],
  ETC: [
    { name: "애견화동", value: "DOG_FLOWER", key: "etc", typeName: "ETC" },
    { name: "단독홀", value: "SINGLE_HALL", key: "etc", typeName: "ETC" },
    { name: "플라워랩핑", value: "FLOWER_WRAPPING", key: "etc", typeName: "ETC" },
    { name: "커스터마이징", value: "CUSTOMIZING", key: "etc", typeName: "ETC" },
    { name: "대형스크린", value: "LARGE_SCREEN", key: "etc", typeName: "ETC" },
    { name: "돌잔치/연회", value: "FIRST_BIRTHDAY_PARTY_BANQUET", key: "etc", typeName: "ETC" },
    { name: "소규모예식", value: "SMALL_CEREMONY", key: "etc", typeName: "ETC" },
    // { name: '폐백실', value: 'PYEBAEK_ROOM', key: 'etc', typeName: 'ETC' },
    // { name: '신부대기실', value: 'BRIDE_WAITING_ROOM', key: 'etc', typeName: 'ETC' },
    // { name: '천고가 높은(7m 이상)', value: 'HIGH_CEILING', key: 'etc', typeName: 'ETC' },
  ],
  WEDDING_DAY: [
    { name: "금요일", value: "FRIDAY", key: "dayOfWeeks", typeName: "WEDDING_DAY" },
    { name: "토요일", value: "SATURDAY", key: "dayOfWeeks", typeName: "WEDDING_DAY" },
    { name: "일요일", value: "SUNDAY", key: "dayOfWeeks", typeName: "WEDDING_DAY" },
  ],
  WEDDING_TIME: [
    { name: "09:00", value: "09:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "10:00", value: "10:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "11:00", value: "11:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "12:00", value: "12:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "13:00", value: "13:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "14:00", value: "14:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "15:00", value: "15:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "16:00", value: "16:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "17:00", value: "17:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "18:00", value: "18:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "19:00", value: "19:00", key: "weddingTimes", typeName: "WEDDING_TIME" },
    { name: "20:00 ~", value: "20:00 ~", key: "weddingTimes", typeName: "WEDDING_TIME" },
  ],
};
export const MEAL_TYPE = ["뷔페", "한상차림", "코스", "분리예식", "동시예식"];
export const ENTRANCE_METHOD = [
  "신부대기실에서 바로 입장",
  "계단을 통해 입장",
  "히든공간 통해서 입장",
  "리프트를 입장",
  "정면에서 입장",
  "로비에서 입장",
  "ㄱ자 입장",
  "ㄴ자 입장",
  "ㄷ자 입장",
  "기타",
];
export const PARKING = [];

export const SLOT_FILTER_DATA: {
  [key in FilterNameKey]?: {
    name: string;
    key: string | string[];
    value?: string | string[];
    typeName: FilterNameKey;
  }[];
} = {
  // value: 서버로 보낼 데이터가 고정된 경우. 만약 value가 없다면 고정 되지 않은 값이라 이 데이터를 가져가서 사용하는 곳 에서 직접 설정해줘야함.
  // key: 서버로 보낼 파라미터 이름
  HALL_TYPE: [
    { name: "밝은", value: "BRIGHT", key: "styles", typeName: "HALL_TYPE" },
    { name: "어두운", value: "DARK", key: "styles", typeName: "HALL_TYPE" },
    { name: "채플", value: "CHAPEL", key: "styles", typeName: "HALL_TYPE" },
    { name: "컨벤션", value: "CONVENTION", key: "styles", typeName: "HALL_TYPE" },
    { name: "하우스", value: "HOUSE", key: "styles", typeName: "HALL_TYPE" },
    { name: "호텔", value: "HOTEL", key: "styles", typeName: "HALL_TYPE" },
    { name: "야외", value: "OUTDOOR", key: "styles", typeName: "HALL_TYPE" },
    { name: "한옥", value: "HANOK", key: "styles", typeName: "HALL_TYPE" },
    { name: "소규모", value: "SMALL_SCALE", key: "styles", typeName: "HALL_TYPE" },
  ],
  MEAL_TYPE: [
    { name: "뷔페", value: "BUFFET", key: "mealTypes", typeName: "MEAL_TYPE" },
    { name: "한상차림", value: "ONE_TABLE", key: "mealTypes", typeName: "MEAL_TYPE" },
    { name: "코스", value: "COURSE", key: "mealTypes", typeName: "MEAL_TYPE" },
    {
      name: "한상차림 + 세미뷔페",
      value: "ONE_TABLE_WITH_SEMI_BUFFET",
      key: "mealTypes",
      typeName: "MEAL_TYPE",
    },
  ],
  PARK_TRAFFIC: [
    {
      name: "지하철역에서 도보 15분 이내",
      key: "trafficTypes",
      value: "STATION_AREA",
      typeName: "PARK_TRAFFIC",
    },
    { name: "셔틀버스 운행", key: "trafficTypes", value: "SHUTTLE", typeName: "PARK_TRAFFIC" },
    {
      name: "대절버스 주차 가능",
      key: "trafficTypes",
      value: "BUS_RENT",
      typeName: "PARK_TRAFFIC",
    },
  ],
  WEDDING_METHOD: [
    { name: "분리예식", value: "SEPARATION", key: "ceremonyTypes", typeName: "WEDDING_METHOD" },
    { name: "동시예식", value: "SAME_TIME", key: "ceremonyTypes", typeName: "WEDDING_METHOD" },
  ],
};
